var HttpClient = function() {
  this.get = function(aUrl, aCallback) {
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function() { 
      if (httpRequest.readyState == 4 && httpRequest.status == 200)
        aCallback(httpRequest.responseText);
    }
    httpRequest.open( "GET", aUrl, true );            
    httpRequest.send( null );
    return aCallback;
  }
}

var client = new HttpClient();
client.get('https://ipinfo.io/json', function(responseFunc) {
  var jsonResponse = JSON.parse(responseFunc);
  let country = jsonResponse.country;
  let countries = ['IE', 'GB', 'AT', 'BE', 'DE', 'FR', 'NL', 'LU', 'FI', 'RO', 'BG', 'HR', 'CZ', 'PL', 'SI', 'HU', 'DK', 'SK', 'LT', 'SE', 'IT', 'HR', 'EE', 'LV'];
  if (country == 'PT') {
    window['freeShippingPT'] = function ({cart, smart_cart, rule, customer, meta_value}) {
      cart_price = cart.total_price;
      customer_tags = customer.tags;
      var client = new HttpClient();
      let country = "";
      client.get('https://ipinfo.io/json', function (response) {
        var jsonResponse = JSON.parse(response);
        country = jsonResponse.country;
        if (Number(cart_price) > 3999 && country == 'PT') {
          if (customer_tags && customer_tags.includes("colaborador")) {
            console.log("false contains tag")
            return false;
          } else {
            console.log("true")
            return true;
          }
        } else {
          console.log("false price low or not in correct domain")
          return false
        }
      });
    }
  }
  if (country == 'ES') {
    window['freeShippingES'] = function ({cart, smart_cart, rule, customer, meta_value}) {
      cart_price = cart.total_price;
      customer_tags = customer.tags;
      var client = new HttpClient();
      let country = "";
      client.get('https://ipinfo.io/json', function (response) {
        var jsonResponse = JSON.parse(response);
        country = jsonResponse.country;
        if (Number(cart_price) > 8999 && country == 'ES') {
          if (customer_tags && customer_tags.includes("colaborador")) {
            console.log("false contains tag")
            return false;
          } else {
            console.log("true")
            return true;
          }
        } else {
          console.log("false price low or not in correct domain")
          return false
        }
      });
    }
  }

  if (countries.includes(country)) {
    window['freeShippingALL'] = function ({cart, smart_cart, rule, customer, meta_value}) {
      cart_price = cart.total_price;
      customer_tags = customer.tags;
      var client = new HttpClient();
      let country = "";
      let countries = [];
      client.get('https://ipinfo.io/json', function (response) {
        var jsonResponse = JSON.parse(response);
        country = jsonResponse.country;
        countries = ['IE', 'GB', 'AT', 'BE', 'DE', 'FR', 'NL', 'LU', 'FI', 'RO', 'BG', 'HR', 'CZ', 'PL', 'SI', 'HU', 'DK', 'SK', 'LT', 'SE', 'IT', 'HR', 'EE', 'LV'];
        if (Number(cart_price) > 14999 && countries.includes(country)) {
          if (customer_tags && customer_tags.includes("colaborador")) {
            console.log("false contains tag")
            return false;
          } else {
            console.log("true")
            return true;
          }
        } else {
          console.log("false price low or not in correct domain")
          return false
        }
      });
    }
  }
});